import {clsx} from 'clsx'

import {VALUES} from '../../constants/values'
import {type TimelineItemIdentity, timelineItemKey} from '../../utils/timeline-item-key'
import {TimelineDivider} from './TimelineDivider'
import styles from './TimelineRowBorder.module.css'

export type TimelineRowBorderProps = {
  children: React.ReactNode
  addDivider: boolean
  showDividerLine?: boolean
  item: TimelineItemIdentity
  isMajor?: boolean
  isHighlighted?: boolean
  className?: string
  commentParams?: TimelineRowBorderCommentParams
  ref?: React.Ref<HTMLDivElement>
}

export type TimelineRowBorderCommentParams = {
  first: boolean
  last: boolean
  viewerDidAuthor?: boolean
}

export const TimelineRowBorder = ({ref, ...props}: TimelineRowBorderProps) => {
  const {children, addDivider, showDividerLine = true, item, isMajor, isHighlighted, commentParams, className} = props

  const key = timelineItemKey(item)
  const dataProps = {
    [VALUES.timeline.dataTimelineEventId]: key,
    'data-highlighted-event': isHighlighted,
  }
  return (
    <div className={styles.Box}>
      {addDivider && <TimelineDivider id={key} showLine={showDividerLine} />}
      <div
        {...dataProps}
        ref={ref}
        className={clsx(
          styles.shared,
          isMajor && styles.major,
          isMajor && commentParams?.viewerDidAuthor && styles.viewerDidAuthor,
          !isMajor && styles.default,
          isHighlighted && styles.highlighted,
          className,
        )}
        data-testid={`timeline-row-border-${key}`}
      >
        {children}
      </div>
    </div>
  )
}
TimelineRowBorder.displayName = 'TimelineRowBorder'
